import type { BudgetEntry } from '../types'

export function getLockedPeriodsFromBudgetTable(): Array<string | undefined> {
  const budgetLocks = document.querySelectorAll(
    '.period-column.budget-locked [data-behaviour="budget-lock"]'
  )
  return [...budgetLocks].map(
    (el: Element) => (el as HTMLElement).dataset.period
  )
}

export function getAccountIdsWithoutData(): string[] {
  const accounts = [
    ...document.querySelectorAll('[data-budget-type="account"]'),
  ]

  return accounts.reduce((accountIdsWithoutData, account) => {
    const accountValues = account.querySelectorAll('input:not(:disabled)')

    const accountData = [...accountValues].every(
      (el: Element) => (el as HTMLInputElement).value === ''
    )
      ? (account as HTMLElement).dataset.elementId
      : false

    if (accountData) {
      accountIdsWithoutData.push(accountData)
    }

    return accountIdsWithoutData
  }, [] as string[])
}

type UrlOptions = {
  firm_id: string
  company_id: string
  budget_set_id: string | undefined
  period: string
  budget_period: string | undefined
  locked_periods: Array<string | undefined>
}

export function getUrlOptionsFromBudgetTable(): UrlOptions {
  // TODO: Move this into the refactored budget
  const table = document.querySelector('table.budget-table') as HTMLElement
  // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
  const entriesFilter: Record<string, string> = JSON.parse(
    table.dataset.entriesFilter || '{}'
  )

  let urlOptions = {
    firm_id: window.Silverfin.currentFirmId,
    company_id: window.Silverfin.currentCompanyId,
    budget_set_id: table.dataset.budgetSetId,
    period: (
      document.querySelector(
        '[data-behaviour="budget-origin-period"]'
      ) as HTMLInputElement
    ).value,
    budget_period: table.dataset.period,
    locked_periods: getLockedPeriodsFromBudgetTable(),
  }

  if (entriesFilter instanceof Object) {
    urlOptions = {
      ...urlOptions,
      ...entriesFilter,
    }
  }

  return urlOptions
}

export function renderBudgetEntries(budgetEntries: BudgetEntry[]): void {
  // TODO: Refactor this filling out of values into the main budget table when its in vue
  budgetEntries.map((entry) => {
    const row = document.querySelectorAll(
      `tr[data-element-id="${entry.elementId}"] .budget-cell`
    )
    const input = row[entry.periodIndex].querySelector(
      'input'
    ) as HTMLInputElement

    input.value = entry.value
  })

  const event = new Event('calculate-budget-totals')
  document.dispatchEvent(event)
}
